var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDcSaved(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 153.63 153.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Degradado_sin_nombre_18);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_18",
    x1: 39.51,
    y1: 15.51,
    x2: 119.68,
    y2: 147.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbf20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff5334"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.37,48.23a5.47,5.47,0,0,1,0,7.79L67,105.4A5.44,5.44,0,0,1,63.1,107h-.33a5.47,5.47,0,0,1-4-2.08l-22-27.44a5.49,5.49,0,1,1,8.56-6.8l18.11,22.6,45-45a5.47,5.47,0,0,1,7.79,0Zm37.26,28.58a76.82,76.82,0,1,1-22.5-54.31,76.86,76.86,0,0,1,22.5,54.31Zm-11,0a65.83,65.83,0,1,0-19.28,46.56,65.8,65.8,0,0,0,19.28-46.56Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcSaved);
export default __webpack_public_path__ + "static/media/DC_saved.68887a95c1922981bc0cbbffaed154df.svg";
export { ForwardRef as ReactComponent };